import { call, put, takeLatest } from 'redux-saga/effects';

import * as highlightActions from './highlightActions.js';
import { updateHighlightApiCall } from './highlightAPI.js';

function* updateHighlightSaga({ payload }) {
  try {
    const { data } = yield call(updateHighlightApiCall, payload);
    yield put(highlightActions.highlightUpdateStore(data));
  } catch (error) {
    yield put(highlightActions.highlightUpdateError(error.Message ? error.Message : error.toString()));
  }
}

export function* highlightWatcher() {
  yield takeLatest(highlightActions.highlightUpdateRequest.type, updateHighlightSaga);
}
